import { Anomaly } from '@rtls/core/models/statistics/anomaly.model';
import {
	AnomalyHolder,
	AnomalyKeys,
	Business,
	RatesHolder,
	StatsHolder,
	TotalsHolder,
} from '@rtls/core/models/statistics/business.model';
import {
	randomName,
	randomNumber,
	randomSentence,
	randomSeverity,
	randomWord,
} from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts';

export const anomalyFactory = Factory.makeFactory<Anomaly>({
	count: Factory.each(() => randomNumber()),
	key: Factory.each(() => randomWord()),
	severity: Factory.each(() => randomSeverity()),
	translation: Factory.each(() => randomName()),
});

export const ratesFactory = Factory.makeFactory<RatesHolder>({
	availability: Factory.each(() => anomalyFactory.build()),
	operating: Factory.each(() => anomalyFactory.build()),
});

export const totalsFactory = Factory.makeFactory<TotalsHolder>({
	nb_things: Factory.each(() => anomalyFactory.build()),
	nb_convoys: Factory.each(() => anomalyFactory.build()),
	nb_late_convoys: Factory.each(() => anomalyFactory.build()),
	nb_transports: Factory.each(() => anomalyFactory.build()),
	nb_late_transports: Factory.each(() => anomalyFactory.build()),
	nb_inventory_delay_alert: Factory.each(() => anomalyFactory.build()),
	nb_inventory_threshold_alert: Factory.each(() => anomalyFactory.build()),
});

export const anomalyKeysFactory = Factory.makeFactory<AnomalyKeys>({
	keys: Factory.each(() => anomalyFactory.build()),
});

export const anomalyHolderFactory = Factory.makeFactory<AnomalyHolder>({
	count: Factory.each(() => randomNumber()),
	translation: Factory.each(() => randomSentence()),
	keys: Factory.each(() => anomalyKeysFactory.build()),
});

export const statsHolderFactory = Factory.makeFactory<StatsHolder>({
	location: Factory.each(() => anomalyHolderFactory.build()),
	retention: Factory.each(() => anomalyHolderFactory.build()),
	area_of_operation: Factory.each(() => anomalyHolderFactory.build()),
	unauthorized_movement: Factory.each(() => anomalyHolderFactory.build()),
	location_by_thing_type: Factory.each(() => anomalyHolderFactory.build()),
});

export const businessFactory = Factory.makeFactory<Business>({
	count: Factory.each(() => randomNumber()),
	stats: Factory.each(() => statsHolderFactory.build()),
	totals: Factory.each(() => totalsFactory.build()),
	rates: Factory.each(() => ratesFactory.build()),
});

// We need to reuse key in order to be useful in the dashboard :/
export function randomAnomalyHolder(holder?: AnomalyHolder): Business {
	return businessFactory.build();
}
